
import {ContactPriceRule} from "@/models/base/contact-price-rule";
import AppProductSkuAutocomplete from "@/components/products/ProductSkuAutocompleteWithoutModal.vue";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowse.vue";
import AppProductEditGroups from "@/components/products/ProductEditGroupsLight.vue";
import AppFilterItem from "./PriceRuleEditFilterItem.vue";
import Vue from "vue";
import {Condition, Operator} from "@/utils/condition/condition";
import AppSellCategorySelect from "@/components/SellCategorySelect.vue";
import {Contact, Product} from "@/models/base";
import {TranslateResult} from "vue-i18n";
import {ISelectItem} from "winfakt-vue-components";
import {ProductGroupModel} from "@/models/base/product-group-model";
import {ProductGroupService} from "@/services";
import {ProductGroup} from "@/models/base/product-group";
import { IPriceRule } from "@/utils/price-rule";

export default Vue.extend({
	data() {
		return {
			rule: {} as any as IPriceRule,
			product: new Product(),
			addContact: new Contact(),
			openedCondition: null as null | Condition,
			activeTab: 0,
			activeQuickFilter: 0,
			amount: 0
		};
	},
	props: {
		value: {
			type: Object as () => IPriceRule,
			required: true
		},
		defaultPriceCategory: {
			type: Number,
			default: 1
		},
		onSaveFunction: {
			type: Function
		}
	},
	computed: {
		disableSellPrice(): boolean {
			return this.rule.BuyPercentage != 0 || this.rule.BuyAmount != 0;
		},
		disableBuyPrice() {
			return this.rule.Price != 0 || this.rule.Discount != 0;
		},
		tabs(): TranslateResult[] {
			return Object.values(this.$ct("price-rule-tabs"));
		},
		select(): ISelectItem<number>[] {
			return Object.values(this.$ct("price-rule-quick-filter-select")).map((k, v) => {
				return {value: v, text: k};
			});
		},
	},
	watch: {
		value: {
			immediate: true,
			handler(value: ContactPriceRule) {
				this.rule = this.value.makeCopy();
				if (this.rule.PriceCategory == 0) {
					this.rule.PriceCategory = this.defaultPriceCategory;
				}
			}
		}
	},
	methods: {
		close() {
			this.$emit("close");
		},
		async save() {
			if (this.onSaveFunction){
				this.rule = await this.onSaveFunction(this.rule);
			}
			this.$emit("input", this.rule.makeCopy());
			this.close();
		},
		addNewFilter() {
			let condition = new Condition();
			condition.Prop = "ProductSku",
			condition.Operator = Operator.EQ;
			condition.Value = "1";
			this.rule.Filters.push(condition);
			this.openedCondition = condition;
		},
		deleteItem(i: number) {
			this.rule.Filters.splice(i, 1);
		},
		editItem(item: Condition) {
			if (this.openedCondition == item) {
				this.openedCondition = null;
				return;
			}
			this.openedCondition = item;
		},
		onSingleProduct(item:Product) {
			let c = new Condition({"Prop": "ProductSku","Operator": 0,"Value": item.Sku,"Info": "Art. = '" + item.Name + "' ("+item.Sku+")"});
			this.rule.Filters.push(c);
		},onProductSelect(items:Product[]) {
			let i = items.length > 1 ? true : false;
			items.forEach((item:Product) => {
				let c = new Condition({"IsOr": i,"Prop": "ProductSku","Operator": 0,"Value": item.Sku,"Info": "Art. = '" + item.Name + "' ("+item.Sku+")"});
				this.rule.Filters.push(c);
			});
		},
		onSupplierSelect(item:Contact) {
			let c = new Condition({"Prop": "Product.MainSupplier.Contact.ComputedFriendlyID"
				,"Operator": 0
				,"Value": item.ComputedFriendlyID
				,"Info": "Lev. = '" + item.MainAddress?.CompanyOrFullName + "' ("+item.ComputedFriendlyID+")"});
			this.rule.Filters.push(c);
			return false;
		},
		onQtySelect() {
			let c = new Condition({"Prop": "Amount","Operator": 4,"Value": this.amount.toString()});
			this.rule.Filters.push(c);
			this.amount = 0;
			return false;
		},
		async onGroupSubmit(){

			if(this.product.MainGroup){
				let g = await this.getGroupInfo(this.product.MainGroup.ID);
				console.log(g);
				let c = new Condition(
					{"IsOr": true,"Prop": "Product.MainGroup.ParentGroupID","Operator": 0,
						"Value": this.product.MainGroup.ID.toString(),"Info": "Bovenliggende groep='" + g.Name + "''"});
				this.rule.Filters.push(c);
				c = new Condition({"IsOr": true,"Prop": "Product.MainGroup.ID","Operator": 0,
					"Value": this.product.MainGroup.ID.toString(),"Info": "Groep='"+g.Name+"'"});
				this.rule.Filters.push(c);

				this.amount = 0;
				return false;
			}

			if(this.product.GroupID){
				let g = await this.getGroupInfo(this.product.GroupID);
				let c = new Condition({"Prop": "Product.GroupID","Operator": 0,"Value": this.product.GroupID.toString(),"Info": "Subgroep='"+g.Name+"'"});
				this.rule.Filters.push(c);
				this.amount = 0;
				return false;
			}
		},
		setMainGroup(id:number){
			this.product.MainGroup = new ProductGroupModel({ID: id});
			this.product.GroupID = id;
		},
		async getGroupInfo(id:number):Promise<ProductGroup>{
			return ProductGroupService.getGroupByID(id);
		}
	},
	components: {
		AppFilterItem,
		AppSellCategorySelect,
		AppProductSkuAutocomplete,
		AppProductEditGroups,
		AppContactSearch
	},
	i18nEx: {
		componentPrefix: "components.contacts"
	}
});
